import React from 'react';

function MasterData() {

  return (
    <React.Fragment>
      <h1>Master Data</h1>
    </React.Fragment>
  );
}

export default MasterData;
